<template>
  <el-container class="layout-container">
    <!-- 侧边栏 -->
    <el-aside :width="isCollapse ? '64px' : '220px'" class="layout-aside">
      <div class="logo-box" @click="$router.push('/home')">
        <i class="el-icon-s-management logo-icon"></i>
        <span v-show="!isCollapse" class="logo-text">安考通</span>
      </div>
      <el-menu
        :default-active="activeMenu"
        :collapse="isCollapse"
        :collapse-transition="false"
        background-color="#304156"
        text-color="#bfcbd9"
        active-text-color="#409EFF"
        router
      >
        <el-menu-item index="/home">
          <i class="el-icon-s-home"></i>
          <span slot="title">首页</span>
        </el-menu-item>
        <el-menu-item index="/question-bank">
          <i class="el-icon-s-order"></i>
          <span slot="title">题库</span>
        </el-menu-item>
        <el-menu-item index="/quick-search">
          <i class="el-icon-search"></i>
          <span slot="title">快速搜题</span>
        </el-menu-item>
        <el-menu-item index="/wrong-paper">
          <i class="el-icon-s-opportunity"></i>
          <span slot="title">错题练习</span>
        </el-menu-item>
        <el-menu-item index="/mine">
          <i class="el-icon-user-solid"></i>
          <span slot="title">我的</span>
        </el-menu-item>
      </el-menu>
    </el-aside>

    <el-container>
      <!-- 顶部栏 -->
      <el-header class="layout-header" height="56px">
        <div class="header-left">
          <i
            :class="isCollapse ? 'el-icon-s-unfold' : 'el-icon-s-fold'"
            class="collapse-btn"
            @click="isCollapse = !isCollapse"
          ></i>
          <span class="header-title">安考通 - 安全考试培训平台</span>
        </div>
        <div class="header-right">
          <!-- 科目选择 -->
          <el-dropdown v-if="subjectName" @command="handleSubjectChange" trigger="click">
            <span class="subject-selector">
              <i class="el-icon-collection-tag"></i>
              {{ subjectName }}
              <i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="switch">切换科目</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <span class="header-user" v-if="userInfo">
            <i class="el-icon-user"></i>
            {{ userInfo.nickName || '用户' }}
          </span>
        </div>
      </el-header>

      <!-- 主内容区 -->
      <el-main class="layout-main">
        <router-view />
      </el-main>

      <!-- 底部版权 -->
      <el-footer class="layout-footer" height="36px">
        © 2026 安康职业安全教育
      </el-footer>
    </el-container>

    <!-- 科目选择弹窗 -->
    <el-dialog
      title="选择科目"
      :visible.sync="subjectDialogVisible"
      width="720px"
      :close-on-click-modal="false"
    >
      <el-row :gutter="16">
        <el-col :span="8" v-for="item in subjectList" :key="item.id">
          <div
            class="subject-card"
            :class="{ active: selectedSubjectId === item.id }"
            @click="selectSubject(item)"
          >
            <div class="subject-card-name">{{ item.name }}</div>
            <div class="subject-card-desc" v-if="item.description">{{ item.description }}</div>
          </div>
        </el-col>
      </el-row>
      <div v-if="childrenSubjects.length > 0" style="margin-top: 20px">
        <el-divider>子科目</el-divider>
        <el-row :gutter="16">
          <el-col :span="8" v-for="item in childrenSubjects" :key="item.id">
            <div
              class="subject-card"
              :class="{ active: tempSubjectId === item.id }"
              @click="selectChildSubject(item)"
            >
              <div class="subject-card-name">{{ item.name }}</div>
            </div>
          </el-col>
        </el-row>
      </div>
      <span slot="footer">
        <el-button @click="subjectDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="confirmSubject">确定</el-button>
      </span>
    </el-dialog>
  </el-container>
</template>

<script>
import { mapState } from 'vuex'
import { getSubjects, getSubjectByPid } from '@/api'

export default {
  name: 'Layout',
  data() {
    return {
      isCollapse: false,
      subjectDialogVisible: false,
      subjectList: [],
      selectedSubjectId: null,
      selectedSubjectName: '',
      childrenSubjects: [],
      tempSubjectId: null,
      tempSubjectName: '',
      tempSubject: null
    }
  },
  computed: {
    ...mapState(['userInfo', 'subjectId', 'subjectName']),
    activeMenu() {
      const path = this.$route.path
      if (path.startsWith('/home')) return '/home'
      if (path.startsWith('/question-bank')) return '/question-bank'
      if (path.startsWith('/quick-search')) return '/quick-search'
      if (path.startsWith('/wrong-paper')) return '/wrong-paper'
      if (path.startsWith('/mine')) return '/mine'
      return '/home'
    }
  },
  created() {
    this.$store.dispatch('initDefaultSubject')
    this.$store.dispatch('fetchAuthInfo')
  },
  methods: {
    handleSubjectChange(cmd) {
      if (cmd === 'switch') {
        this.openSubjectDialog()
      }
    },
    async openSubjectDialog() {
      this.subjectDialogVisible = true
      this.childrenSubjects = []
      this.tempSubjectId = null
      this.tempSubjectName = ''
      this.tempSubject = null
      try {
        const data = await getSubjects()
        this.subjectList = Array.isArray(data) ? data : []
      } catch (e) {
        this.subjectList = []
      }
    },
    async selectSubject(item) {
      this.selectedSubjectId = item.id
      this.selectedSubjectName = item.name
      this.tempSubject = item
      this.tempSubjectId = null
      this.tempSubjectName = ''
      // 加载子科目
      try {
        const data = await getSubjectByPid(item.id, null)
        this.childrenSubjects = Array.isArray(data) ? data : []
      } catch (e) {
        this.childrenSubjects = []
      }
    },
    selectChildSubject(item) {
      this.tempSubjectId = item.id
      this.tempSubjectName = item.name
      this.tempSubject = item
    },
    confirmSubject() {
      const subject = this.tempSubjectId
        ? { id: this.tempSubjectId, name: this.tempSubjectName }
        : { id: this.selectedSubjectId, name: this.selectedSubjectName }
      if (subject.id) {
        this.$store.dispatch('saveCurrentSubject', subject)
        this.subjectDialogVisible = false
        this.$message.success(`已切换至: ${subject.name}`)
        // 刷新当前页面
        this.$router.go(0)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.layout-container {
  height: 100vh;
  > .el-container {
    flex-direction: column;
    height: 100%;
    overflow: hidden;
  }
}

.layout-aside {
  background-color: #304156;
  overflow: hidden;
  transition: width 0.3s;

  .logo-box {
    height: 56px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    background-color: #263445;
    .logo-icon {
      font-size: 24px;
      color: #409EFF;
    }
    .logo-text {
      font-size: 20px;
      font-weight: bold;
      color: #fff;
      margin-left: 10px;
    }
  }

  .el-menu {
    border-right: none;
  }
}

.layout-header {
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px;
  box-shadow: 0 1px 4px rgba(0,0,0,.08);

  .header-left {
    display: flex;
    align-items: center;
    .collapse-btn {
      font-size: 22px;
      cursor: pointer;
      color: #606266;
      &:hover { color: #409EFF; }
    }
    .header-title {
      margin-left: 16px;
      font-size: 16px;
      font-weight: 600;
      color: #303133;
    }
  }

  .header-right {
    display: flex;
    align-items: center;
    gap: 20px;
    .subject-selector {
      cursor: pointer;
      padding: 6px 12px;
      border-radius: 4px;
      background: #ecf5ff;
      color: #409EFF;
      font-size: 14px;
    }
    .header-user {
      color: #606266;
      font-size: 14px;
    }
  }
}

.layout-main {
  background: #f5f6fa;
  padding: 20px;
  overflow-y: auto;
}

.layout-footer {
  background: #fff;
  border-top: 1px solid #e4e7ed;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  color: #909399;
  flex-shrink: 0;
}

.subject-card {
  border: 1px solid #dcdfe6;
  border-radius: 6px;
  padding: 16px;
  text-align: center;
  cursor: pointer;
  margin-bottom: 12px;
  transition: all 0.3s;

  &:hover {
    border-color: #409EFF;
  }

  &.active {
    border-color: #409EFF;
    background: #ecf5ff;
    color: #409EFF;
  }

  .subject-card-name {
    font-size: 15px;
    font-weight: 600;
    margin-bottom: 4px;
  }
  .subject-card-desc {
    font-size: 12px;
    color: #909399;
  }
}
</style>
